import { useEffect, useState } from "react";
import api from "@/lib/api";
import { NuovoContoModal } from "@/components/prima_nota/VocePicker";
import PrimaNotaBilancioSchemaPage from "@/pages/PrimaNotaBilancioSchemaPage";

const fmt = n => Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function PrimaNotaTabellePage() {
  const [tab, setTab] = useState("contatori");
  return (
    <div>
      <div className="sw-page-title">
        <h1>📋 Tabelle</h1>
      </div>
      <div style={{ margin: "8px 20px 0", display: "flex", gap: 0, borderBottom: "2px solid #6a1b9a" }}>
        <TabButton active={tab === "contatori"} onClick={() => setTab("contatori")} testid="pn-tab-contatori" color="#6a1b9a">🔢 Causali</TabButton>
        <TabButton active={tab === "riparti"} onClick={() => setTab("riparti")} testid="pn-tab-riparti" color="#00695c">📋 Riparti</TabButton>
        <TabButton active={tab === "mapping_ricavi"} onClick={() => setTab("mapping_ricavi")} testid="pn-tab-mapping-ricavi" color="#1b5e20">💰 Mapping Ricavi</TabButton>
        <TabButton active={tab === "piano_conti"} onClick={() => setTab("piano_conti")} testid="pn-tab-piano-conti" color="#1565c0">📑 Piano dei Conti</TabButton>
        <div style={{ flex: 1 }} />
      </div>
      <div style={{ margin: tab === "piano_conti" ? 0 : "0 20px 20px" }}>
        {tab === "piano_conti" && <PrimaNotaBilancioSchemaPage />}
        {tab === "contatori" && <ContatoriTab />}
        {tab === "riparti" && <RipartiTab />}
        {tab === "mapping_ricavi" && <MappingRicaviTab />}
      </div>
    </div>
  );
}

function ContatoriTab() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(null);
  const carica = async () => {
    setLoading(true);
    try { const r = await api.get("/pn/contatori"); setList(r.data.data || []); }
    finally { setLoading(false); }
  };
  useEffect(() => { carica(); }, []);

  const apriNuovo = () => {
    const thisYear = new Date().getFullYear();
    setEditing({ _isNew: true, esercizio: thisYear, id: 1, descrizione: "Fatture Acquisto", progressivo: 0, segno: "+" });
  };
  const apriEdit = (c) => setEditing({ ...c, segno: c.segno === "-" ? "-" : "+" });
  const elimina = async (c) => {
    if (!window.confirm(`Eliminare la causale ${c.esercizio}/${c.id} (${c.descrizione || ""})? Progressivo attuale: ${c.progressivo}`)) return;
    try {
      await api.delete(`/pn/contatori/${c.esercizio}/${c.id}`);
      carica();
    } catch (e) { alert(e.response?.data?.detail || "Errore"); }
  };

  return (
    <div style={{ background: "white", border: "1px solid #ccc", borderTop: 0 }}>
      <div style={{ padding: 10, background: "#f5f5f5", borderBottom: "1px solid #ccc", display: "flex", alignItems: "center", gap: 10 }}>
        <span style={{ fontSize: 12, color: "#555" }}>Causali documento per esercizio e tipo, con segno (+ costo / − ricavo). Il progressivo viene auto-incrementato alla creazione di nuove fatture.</span>
        <button onClick={apriNuovo} data-testid="pn-contatore-new"
          style={{ padding: "5px 12px", background: "#6a1b9a", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>+ Nuova causale</button>
        <button onClick={carica} disabled={loading} style={{ padding: "5px 12px", background: "white", color: "#6a1b9a", border: "1px solid #6a1b9a", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>{loading ? "..." : "↻ Aggiorna"}</button>
      </div>
      <table className="sw-table sw-table-compact" style={{ fontSize: 12 }}>
        <thead style={{ background: "#37474f", color: "white" }}>
          <tr>
            <th style={{ width: 40 }}>#</th>
            <th style={{ width: 120 }}>ESERCIZIO</th>
            <th style={{ width: 80, textAlign: "center" }}>ID TIPO</th>
            <th style={{ minWidth: 250 }}>DESCRIZIONE</th>
            <th style={{ width: 70, textAlign: "center" }}>SEGNO</th>
            <th style={{ width: 130, textAlign: "right" }}>PROGRESSIVO</th>
            <th style={{ width: 110, textAlign: "center" }}>AZIONI</th>
          </tr>
        </thead>
        <tbody>
          {list.length === 0 && <tr><td colSpan={7} style={{ padding: 30, textAlign: "center", color: "#888" }}>Nessuna causale.</td></tr>}
          {list.map((c, i) => {
            const seg = c.segno === "-" ? "-" : "+";
            return (
            <tr key={`${c.esercizio}-${c.id}`} data-testid={`pn-contatore-${i}`}>
              <td style={{ textAlign: "center", color: "#888", fontFamily: "monospace" }}>{i+1}</td>
              <td style={{ fontFamily: "monospace", fontWeight: 700, color: "#6a1b9a" }}>{c.esercizio}</td>
              <td style={{ textAlign: "center", fontFamily: "monospace" }}>{c.id}</td>
              <td>{c.descrizione || "—"}</td>
              <td style={{ textAlign: "center", fontFamily: "monospace", fontWeight: 800, fontSize: 14, color: seg === "+" ? "#1b5e20" : "#c62828" }} data-testid={`pn-contatore-segno-${i}`}>{seg}</td>
              <td style={{ textAlign: "right", fontFamily: "monospace", fontWeight: 800, color: "#0d47a1" }}>{c.progressivo || 0}</td>
              <td style={{ textAlign: "center" }}>
                <button onClick={() => apriEdit(c)} data-testid={`pn-contatore-edit-${i}`}
                  style={{ padding: "2px 8px", background: "#1565c0", color: "white", border: "none", fontSize: 10, fontWeight: 700, cursor: "pointer", marginRight: 3 }}>✏</button>
                <button onClick={() => elimina(c)} data-testid={`pn-contatore-del-${i}`}
                  style={{ padding: "2px 8px", background: "white", color: "#c62828", border: "1px solid #c62828", fontSize: 10, fontWeight: 700, cursor: "pointer" }}>🗑</button>
              </td>
            </tr>
            );
          })}
        </tbody>
      </table>
      {editing && <ContatoreEditor c={editing} onClose={() => { setEditing(null); carica(); }} />}
    </div>
  );
}

function ContatoreEditor({ c, onClose }) {
  const [doc, setDoc] = useState(c);
  const [origKey] = useState({ esercizio: c.esercizio, id: c.id }); // salva chiave originale per PUT
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);
  const isNew = !!doc._isNew;
  const set = (k, v) => setDoc(d => ({ ...d, [k]: v }));
  const tipoLabels = { 1: "Fatture Acquisto", 2: "Nota di Credito", 3: "Operazione Extra" };

  const salva = async () => {
    if (!doc.esercizio || !doc.id) { setErr("Esercizio e ID tipo obbligatori"); return; }
    setSaving(true); setErr(null);
    try {
      const id = Number(doc.id);
      const segnoFinale = id === 1 ? "+" : id === 2 ? "-" : (doc.segno === "-" ? "-" : "+");
      const body = {
        esercizio: Number(doc.esercizio),
        id,
        descrizione: doc.descrizione || tipoLabels[id] || "",
        progressivo: Number(doc.progressivo || 0),
        segno: segnoFinale,
      };
      if (isNew) {
        await api.post("/pn/contatori", body);
      } else {
        await api.put(`/pn/contatori/${origKey.esercizio}/${origKey.id}`, body);
      }
      onClose();
    } catch (e) { setErr(e.response?.data?.detail || "Errore"); }
    finally { setSaving(false); }
  };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 600, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div onClick={e => e.stopPropagation()} data-testid="pn-contatore-editor" style={{ background: "white", width: 480 }}>
        <div style={{ background: "#6a1b9a", color: "white", padding: "8px 14px", fontWeight: 700, display: "flex", alignItems: "center", gap: 10 }}>
          <span>{isNew ? "+ Nuova causale" : `✏ Causale ${doc.esercizio}/${doc.id}`}</span>
          <span style={{ flex: 1 }} />
          <button onClick={onClose} style={{ background: "transparent", border: "none", color: "white", cursor: "pointer", fontSize: 16 }}>✕</button>
        </div>
        {err && <div style={{ padding: 8, background: "#fff0f0", color: "#c00", fontSize: 12, fontWeight: 700 }}>{err}</div>}
        <div style={{ padding: 14, display: "flex", flexDirection: "column", gap: 10 }}>
          <div style={{ display: "flex", gap: 10 }}>
            <div style={{ flex: 1 }}>
              <Lab>ESERCIZIO</Lab>
              <input type="number" value={doc.esercizio} onChange={e => set("esercizio", e.target.value)}
                data-testid="pn-contatore-esercizio"
                style={{ width: "100%", padding: "5px 8px", border: "1px solid #888", fontSize: 13, fontFamily: "monospace", textAlign: "center", fontWeight: 700 }} />
            </div>
            <div style={{ flex: 1 }}>
              <Lab>ID TIPO CAUSALE</Lab>
              <select value={doc.id} onChange={e => {
                const id = Number(e.target.value);
                const newSegno = id === 1 ? "+" : id === 2 ? "-" : (doc.segno === "-" ? "-" : "+");
                setDoc(d => ({ ...d, id, descrizione: tipoLabels[id] || "", segno: newSegno }));
              }} data-testid="pn-contatore-id"
                style={{ width: "100%", padding: "5px 8px", border: "1px solid #888", fontSize: 12 }}>
                <option value={1}>1 — Fatture Acquisto</option>
                <option value={2}>2 — Nota di Credito</option>
                <option value={3}>3 — Operazione Extra</option>
              </select>
            </div>
          </div>
          {!isNew && <div style={{ fontSize: 10, color: "#888", fontStyle: "italic" }}>Puoi modificare anche esercizio e id tipo (rinomina la chiave).</div>}
          <div>
            <Lab>DESCRIZIONE</Lab>
            <input type="text" value={doc.descrizione || ""} onChange={e => set("descrizione", e.target.value)}
              data-testid="pn-contatore-descr" style={{ width: "100%", padding: "5px 8px", border: "1px solid #888", fontSize: 12 }} />
          </div>
          <div>
            <Lab>SEGNO</Lab>
            {Number(doc.id) === 3 ? (
              <div style={{ display: "flex", gap: 6 }}>
                {["+", "-"].map(s => (
                  <button
                    key={s}
                    type="button"
                    onClick={() => set("segno", s)}
                    data-testid={`pn-contatore-segno-${s === "+" ? "plus" : "minus"}`}
                    style={{
                      flex: 1,
                      padding: "8px 0",
                      border: `2px solid ${s === "+" ? "#1b5e20" : "#c62828"}`,
                      background: doc.segno === s ? (s === "+" ? "#1b5e20" : "#c62828") : "white",
                      color: doc.segno === s ? "white" : (s === "+" ? "#1b5e20" : "#c62828"),
                      fontWeight: 800,
                      fontSize: 18,
                      cursor: "pointer",
                    }}
                  >
                    {s} {s === "+" ? "Costo" : "Ricavo"}
                  </button>
                ))}
              </div>
            ) : (
              <div data-testid="pn-contatore-segno-locked"
                style={{ padding: "8px 12px", background: Number(doc.id) === 2 ? "#c62828" : "#1b5e20", color: "white", fontWeight: 800, fontSize: 16, textAlign: "center" }}>
                {Number(doc.id) === 2 ? "− RICAVO (auto)" : "+ COSTO (auto)"}
              </div>
            )}
            <div style={{ fontSize: 10, color: "#888", marginTop: 4 }}>
              <b>Fatture (1)</b> sempre <b>+</b> · <b>Note Credito (2)</b> sempre <b>−</b> · <b>Operazione Extra (3)</b> scegli +/− (può essere costo o ricavo).
            </div>
          </div>
          <div>
            <Lab>PROGRESSIVO ATTUALE</Lab>
            <input type="number" value={doc.progressivo} onChange={e => set("progressivo", e.target.value)}
              data-testid="pn-contatore-progressivo"
              style={{ width: "100%", padding: "5px 8px", border: "1px solid #888", fontSize: 14, fontFamily: "monospace", textAlign: "right", fontWeight: 700 }} />
            <div style={{ fontSize: 10, color: "#888", marginTop: 4 }}>Il prossimo documento di questo tipo userà il numero <b>{Number(doc.progressivo || 0) + 1}</b>.</div>
          </div>
        </div>
        <div style={{ padding: 8, display: "flex", gap: 8, justifyContent: "flex-end", background: "#fafafa" }}>
          <button onClick={onClose} style={{ padding: "5px 14px", background: "white", border: "1px solid #555", cursor: "pointer" }}>Annulla</button>
          <button onClick={salva} disabled={saving} data-testid="pn-contatore-save"
            style={{ padding: "5px 14px", background: "#1b5e20", color: "white", border: "none", fontWeight: 700, cursor: "pointer" }}>
            {saving ? "..." : "💾 Salva"}
          </button>
        </div>
      </div>
    </div>
  );
}

const Lab = ({ children }) => <div style={{ fontSize: 11, fontWeight: 700, color: "#37474f", marginBottom: 4 }}>{children}</div>;

function RipartiTab() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(null);
  const carica = async () => {
    setLoading(true);
    try { const r = await api.get("/pn/riparti"); setList(r.data.data || []); }
    finally { setLoading(false); }
  };
  useEffect(() => { carica(); }, []);

  // Calcola millesimi per ogni plesso (su base totale dei pesi)
  const computeMill = (riparto) => {
    const p = riparto.percentuali || {};
    const peso = (k) => (p[k]?.importo_base ?? 0);
    const inf = peso("INFANZIA");
    const pri = peso("PRIMARIA");
    const sec = peso("SECONDARIA");
    const com = peso("COMUNITA") || peso("COMUNITÀ") || peso("COMUNITA'");
    const totPesi = inf + pri + sec + com;
    if (totPesi <= 0) return { inf: 0, pri: 0, sec: 0, com: 0, tot: 0, popolato: false };
    const mInf = Math.round(inf / totPesi * 1000);
    const mPri = Math.round(pri / totPesi * 1000);
    const mSec = Math.round(sec / totPesi * 1000);
    const mCom = 1000 - mInf - mPri - mSec;
    return { inf: mInf, pri: mPri, sec: mSec, com: mCom, tot: mInf + mPri + mSec + mCom, popolato: true };
  };

  const apriNuovo = () => setEditing({ _isNew: true, tipo: "", infanzia: 250, primaria: 250, secondaria: 250, comunita: 250 });
  const apriEdit = (r) => {
    const m = computeMill(r);
    setEditing({ tipo: r.tipo, _origTipo: r.tipo, tipo_id: r.tipo_id, infanzia: m.inf, primaria: m.pri, secondaria: m.sec, comunita: m.com });
  };
  const elimina = async (r) => {
    if (!window.confirm(`Eliminare il riparto "${r.tipo}"? Le 4 righe (Infanzia, Primaria, Secondaria, Comunità) verranno cancellate.`)) return;
    try { await api.delete(`/pn/riparti/${encodeURIComponent(r.tipo)}`); carica(); }
    catch (e) { alert(e.response?.data?.detail || "Errore"); }
  };

  return (
    <div style={{ background: "white", border: "1px solid #ccc", borderTop: 0 }}>
      <div style={{ padding: 10, background: "#f5f5f5", borderBottom: "1px solid #ccc", display: "flex", alignItems: "center", gap: 10 }}>
        <span style={{ fontSize: 12, color: "#555" }}>Tabelle riparto in <b>millesimi</b> (su base 1.000): ogni tipo divide un costo tra i 4 plessi.</span>
        <button onClick={apriNuovo} data-testid="pn-riparto-new"
          style={{ padding: "5px 12px", background: "#00695c", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>+ Nuovo riparto</button>
        <button onClick={carica} disabled={loading}
          style={{ padding: "5px 12px", background: "white", color: "#00695c", border: "1px solid #00695c", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>{loading ? "..." : "↻ Aggiorna"}</button>
      </div>
      <table className="sw-table sw-table-compact" style={{ fontSize: 12 }}>
        <thead style={{ background: "#37474f", color: "white" }}>
          <tr>
            <th style={{ width: 40 }}>#</th>
            <th style={{ width: 60, textAlign: "center" }}>ID</th>
            <th style={{ minWidth: 200 }}>TIPO</th>
            <th style={{ width: 110, textAlign: "right" }}>INFANZIA</th>
            <th style={{ width: 110, textAlign: "right" }}>PRIMARIA</th>
            <th style={{ width: 110, textAlign: "right" }}>SECONDARIA</th>
            <th style={{ width: 110, textAlign: "right" }}>COMUNITÀ</th>
            <th style={{ width: 100, textAlign: "right", background: "#263238", color: "white" }}>TOTALE</th>
            <th style={{ width: 100, textAlign: "center" }}>AZIONI</th>
          </tr>
        </thead>
        <tbody>
          {list.length === 0 && <tr><td colSpan={9} style={{ padding: 30, textAlign: "center", color: "#888" }}>Nessun riparto.</td></tr>}
          {list.map((r, i) => {
            const m = computeMill(r);
            return (
              <tr key={r.tipo} data-testid={`pn-riparto-${i}`}>
                <td style={{ textAlign: "center", color: "#888", fontFamily: "monospace" }}>{i+1}</td>
                <td style={{ textAlign: "center", fontFamily: "monospace", color: "#00695c", fontWeight: 700 }}>{r.tipo_id || "—"}</td>
                <td style={{ fontWeight: 600 }}>{r.tipo}</td>
                {m.popolato ? (
                  <>
                    <td style={{ textAlign: "right", fontFamily: "monospace", fontWeight: 700 }}>{m.inf}</td>
                    <td style={{ textAlign: "right", fontFamily: "monospace", fontWeight: 700 }}>{m.pri}</td>
                    <td style={{ textAlign: "right", fontFamily: "monospace", fontWeight: 700 }}>{m.sec}</td>
                    <td style={{ textAlign: "right", fontFamily: "monospace", fontWeight: 700 }}>{m.com}</td>
                    <td style={{ textAlign: "right", fontFamily: "monospace", fontWeight: 800, background: m.tot === 1000 ? "#e8f5e9" : "#ffebee", color: m.tot === 1000 ? "#1b5e20" : "#c62828" }}>{m.tot}</td>
                  </>
                ) : (
                  <td colSpan={5} style={{ textAlign: "center", color: "#bbb", fontStyle: "italic" }}>non popolato</td>
                )}
                <td style={{ textAlign: "center" }}>
                  <button onClick={() => apriEdit(r)} data-testid={`pn-riparto-edit-${i}`}
                    style={{ padding: "2px 8px", background: "#1565c0", color: "white", border: "none", fontSize: 10, fontWeight: 700, cursor: "pointer", marginRight: 3 }}>✏</button>
                  <button onClick={() => elimina(r)} data-testid={`pn-riparto-del-${i}`}
                    style={{ padding: "2px 8px", background: "white", color: "#c62828", border: "1px solid #c62828", fontSize: 10, fontWeight: 700, cursor: "pointer" }}>🗑</button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {editing && <RipartoEditor r={editing} onClose={() => { setEditing(null); carica(); }} />}
    </div>
  );
}

function RipartoEditor({ r, onClose }) {
  const [doc, setDoc] = useState(r);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);
  const isNew = !!doc._isNew;
  const set = (k, v) => setDoc(d => ({ ...d, [k]: v }));
  const tot = Number(doc.infanzia || 0) + Number(doc.primaria || 0) + Number(doc.secondaria || 0) + Number(doc.comunita || 0);
  const valid = doc.tipo?.trim() && Math.abs(tot - 1000) < 0.01;

  const salva = async () => {
    if (!doc.tipo?.trim()) { setErr("Nome tipo obbligatorio"); return; }
    if (Math.abs(tot - 1000) > 0.01) { setErr(`Il totale deve essere 1000 (attuale: ${tot})`); return; }
    setSaving(true); setErr(null);
    try {
      const body = {
        tipo: doc.tipo.trim(),
        tipo_id: doc.tipo_id ? Number(doc.tipo_id) : null,
        infanzia: Number(doc.infanzia || 0),
        primaria: Number(doc.primaria || 0),
        secondaria: Number(doc.secondaria || 0),
        comunita: Number(doc.comunita || 0),
      };
      if (isNew) await api.post("/pn/riparti", body);
      else await api.put(`/pn/riparti/${encodeURIComponent(doc._origTipo)}`, body);
      onClose();
    } catch (e) { setErr(e.response?.data?.detail || "Errore"); }
    finally { setSaving(false); }
  };

  // Auto-bilancia: distribuisce i 1000 - somma altri sull'ultimo modificato
  const autoBilancia = () => {
    const inf = Math.round(1000 / 4);
    setDoc(d => ({ ...d, infanzia: inf, primaria: inf, secondaria: inf, comunita: 1000 - inf * 3 }));
  };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 600, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div onClick={e => e.stopPropagation()} data-testid="pn-riparto-editor" style={{ background: "white", width: 540 }}>
        <div style={{ background: "#00695c", color: "white", padding: "8px 14px", fontWeight: 700, display: "flex", alignItems: "center", gap: 10 }}>
          <span>{isNew ? "+ Nuovo riparto" : `✏ Riparto: ${doc._origTipo}`}</span>
          <span style={{ flex: 1 }} />
          <button onClick={onClose} style={{ background: "transparent", border: "none", color: "white", cursor: "pointer", fontSize: 16 }}>✕</button>
        </div>
        {err && <div style={{ padding: 8, background: "#fff0f0", color: "#c00", fontSize: 12, fontWeight: 700 }}>{err}</div>}
        <div style={{ padding: 14, display: "flex", flexDirection: "column", gap: 10 }}>
          <div>
            <Lab>NOME RIPARTO</Lab>
            <input type="text" value={doc.tipo || ""} onChange={e => set("tipo", e.target.value)} data-testid="pn-riparto-tipo"
              placeholder="es. Energia Elettrica, Acqua, ..."
              style={{ width: "100%", padding: "6px 10px", border: "1px solid #888", fontSize: 13 }} />
          </div>
          <div style={{ fontSize: 11, color: "#666" }}>Distribuzione in millesimi (su base <b>1000</b>) tra i 4 plessi:</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            {[
              { k: "infanzia", label: "INFANZIA" },
              { k: "primaria", label: "PRIMARIA" },
              { k: "secondaria", label: "SECONDARIA" },
              { k: "comunita", label: "COMUNITÀ" },
            ].map(f => (
              <div key={f.k}>
                <Lab>{f.label}</Lab>
                <input type="number" value={doc[f.k] ?? 0} onChange={e => set(f.k, e.target.value)} data-testid={`pn-riparto-${f.k}`}
                  style={{ width: "100%", padding: "5px 8px", border: "1px solid #888", fontSize: 14, fontFamily: "monospace", textAlign: "right", fontWeight: 700 }} />
              </div>
            ))}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10, padding: 8, background: Math.abs(tot - 1000) < 0.01 ? "#e8f5e9" : "#ffebee", border: `2px solid ${Math.abs(tot - 1000) < 0.01 ? "#1b5e20" : "#c62828"}` }}>
            <span style={{ fontSize: 12, fontWeight: 700, color: Math.abs(tot - 1000) < 0.01 ? "#1b5e20" : "#c62828" }}>TOTALE: {tot} ‰</span>
            <span style={{ fontSize: 11, color: "#666" }}>(deve essere 1000)</span>
            <button onClick={autoBilancia} type="button" style={{ marginLeft: "auto", padding: "3px 10px", background: "white", border: "1px solid #00695c", color: "#00695c", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>⚖ 250×4</button>
          </div>
        </div>
        <div style={{ padding: 8, display: "flex", gap: 8, justifyContent: "flex-end", background: "#fafafa" }}>
          <button onClick={onClose} style={{ padding: "5px 14px", background: "white", border: "1px solid #555", cursor: "pointer" }}>Annulla</button>
          <button onClick={salva} disabled={!valid || saving} data-testid="pn-riparto-save"
            style={{ padding: "5px 14px", background: valid ? "#1b5e20" : "#ccc", color: "white", border: "none", fontWeight: 700, cursor: valid ? "pointer" : "not-allowed" }}>
            {saving ? "..." : "💾 Salva"}
          </button>
        </div>
      </div>
    </div>
  );
}

const TabButton = ({ active, onClick, color, children, testid }) => (
  <button onClick={onClick} data-testid={testid}
    style={{
      padding: "6px 18px",
      background: active ? color : "#eee",
      color: active ? "white" : "#666",
      border: "none",
      borderTop: active ? `2px solid ${color}` : "2px solid #ccc",
      borderLeft: "1px solid #ccc",
      borderRight: "1px solid #ccc",
      fontSize: 12,
      fontWeight: 700,
      cursor: "pointer",
    }}>
    {children}
  </button>
);


// =================== MAPPING RICAVI ===================
function MappingRicaviTab() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [stats, setStats] = useState({ total: 0, mappati: 0, non_mappati: 0 });
  const [pickerOpen, setPickerOpen] = useState(false);
  const [pickerCau, setPickerCau] = useState(null);
  const [voci, setVoci] = useState([]);

  const carica = async () => {
    setLoading(true);
    try {
      const r = await api.get("/pn/mapping/ricavi");
      setList(r.data.data || []);
      setStats({ total: r.data.total || 0, mappati: r.data.mappati || 0, non_mappati: r.data.non_mappati || 0 });
    } catch { /* noop */ }
    finally { setLoading(false); }
  };
  useEffect(() => { carica(); }, []);
  useEffect(() => {
    if (pickerOpen && voci.length === 0) {
      // Carica TUTTE le voci e mostra solo quelle "Ricavi" — usa la sezione c0
      // della voce di livello 1 con descrizione contenente "ricav".
      api.get("/pn/bilancio-voci").then(r => {
        const all = r.data.data || [];
        const root = all.find(v => v.livello === 1 && (v.descrizione || "").toLowerCase().includes("ricav"));
        const sez = root ? root.c0 : null;
        if (sez != null) {
          setVoci(all.filter(v => v.c0 === sez));
        } else {
          // Fallback: mostra tutte le foglie
          setVoci(all.filter(v => v.is_foglia));
        }
      });
    }
  }, [pickerOpen, voci.length]);

  const filtered = search
    ? list.filter(r => `${r.cau_code} ${r.cau_des} ${r.conto_descrizione || ""}`.toLowerCase().includes(search.toLowerCase()))
    : list;

  const automap = async () => {
    if (!window.confirm("Auto-mappare le causali ai conti foglia in sezione 9 (RICAVI) con descrizione coincidente?\nNon sovrascrive mapping esistenti.")) return;
    try {
      const r = await api.post("/pn/mapping/ricavi/automap");
      const nf = r.data.not_found || [];
      alert(`Auto-map completata.\nMappati: ${r.data.matched}\nGià mappati: ${r.data.skipped_existing}\nNon trovati: ${nf.length}${nf.length ? "\n• " + nf.map(n => n.cau_des).join("\n• ") : ""}`);
      carica();
    } catch (e) { alert(e.response?.data?.detail || "Errore"); }
  };

  const apriPicker = (cau) => {
    setVoci([]); // forza refetch alla prossima apertura
    setPickerCau(cau);
    setPickerOpen(true);
  };

  const sceglConto = async (id_conto) => {
    if (!pickerCau) return;
    try {
      await api.put(`/pn/mapping/ricavi/${pickerCau.cau_code}`, {
        cau_code: pickerCau.cau_code, cau_des: pickerCau.cau_des, id_conto: id_conto || null,
      });
      setPickerOpen(false); setPickerCau(null);
      carica();
    } catch (e) { alert(e.response?.data?.detail || "Errore"); }
  };

  const rimuovi = async (cau) => {
    if (!window.confirm(`Rimuovere il mapping della causale ${cau.cau_code} "${cau.cau_des}"?`)) return;
    await api.delete(`/pn/mapping/ricavi/${cau.cau_code}`);
    carica();
  };

  return (
    <div style={{ background: "white", border: "1px solid #ccc", borderTop: 0 }}>
      <div style={{ padding: 10, background: "#f5f5f5", borderBottom: "1px solid #ccc", display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <span style={{ fontSize: 12, color: "#555", flex: "1 1 300px" }}>
          Mappa ogni <b>causale dei Movimenti</b> (Cau / CauDes) a un <b>conto foglia della sezione &quot;Ricavi&quot;</b> del Piano dei Conti.
          Le causali non mappate non saranno conteggiate negli &quot;Incassi Reali&quot; del Bilancio.
        </span>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="🔍 cerca..."
          data-testid="pn-mapping-search" style={{ padding: "5px 10px", border: "1px solid #ccc", fontSize: 12, minWidth: 180 }} />
        <span style={{ padding: "4px 10px", background: stats.non_mappati > 0 ? "#ffebee" : "#e8f5e9", color: stats.non_mappati > 0 ? "#c62828" : "#1b5e20", fontWeight: 700, fontSize: 11 }}>
          {stats.mappati}/{stats.total} mappati
        </span>
        <button onClick={automap} data-testid="pn-mapping-automap"
          style={{ padding: "5px 12px", background: "#1b5e20", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>⚡ Auto-mappa</button>
        <button onClick={carica} disabled={loading} style={{ padding: "5px 12px", background: "white", color: "#1b5e20", border: "1px solid #1b5e20", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>{loading ? "..." : "↻ Aggiorna"}</button>
      </div>
      <table className="sw-table sw-table-compact" style={{ fontSize: 12 }}>
        <thead style={{ background: "#37474f", color: "white" }}>
          <tr>
            <th style={{ width: 40 }}>#</th>
            <th style={{ width: 70 }}>CAU</th>
            <th style={{ minWidth: 220 }}>DESCRIZIONE CAUSALE</th>
            <th style={{ width: 70, textAlign: "right" }}>N° MOV</th>
            <th style={{ width: 130, textAlign: "right" }}>TOT INCASSO €</th>
            <th style={{ width: 90, textAlign: "center" }}>CONTO</th>
            <th style={{ minWidth: 240 }}>VOCE BILANCIO MAPPATA</th>
            <th style={{ width: 130, textAlign: "center" }}>AZIONI</th>
          </tr>
        </thead>
        <tbody>
          {filtered.length === 0 && <tr><td colSpan={8} style={{ padding: 30, textAlign: "center", color: "#888" }}>{loading ? "Caricamento..." : "Nessuna causale."}</td></tr>}
          {filtered.map((r, i) => {
            const mapped = r.id_conto != null;
            return (
              <tr key={r.cau_code} data-testid={`pn-mapping-row-${i}`} style={{ background: mapped ? "white" : "#fff8e1" }}>
                <td style={{ textAlign: "center", color: "#888", fontFamily: "monospace" }}>{i+1}</td>
                <td style={{ fontFamily: "monospace", fontWeight: 700, color: "#0d47a1", textAlign: "center" }}>{r.cau_code}</td>
                <td style={{ fontWeight: 600 }}>{r.cau_des}</td>
                <td style={{ textAlign: "right", fontFamily: "monospace", color: "#555" }}>{r.n_movimenti}</td>
                <td style={{ textAlign: "right", fontFamily: "monospace", fontWeight: 700, color: r.tot_movimenti < 0 ? "#c62828" : "#1b5e20" }}>{fmt(r.tot_movimenti)}</td>
                <td style={{ textAlign: "center", fontFamily: "monospace", fontWeight: 700, color: mapped ? "#0d47a1" : "#c62828" }}>{mapped ? `[${r.id_conto}]` : "—"}</td>
                <td style={{ fontSize: 11 }}>
                  {mapped ? (
                    <span><span style={{ fontFamily: "monospace", color: "#888", marginRight: 6 }}>{r.conto_path}</span>{r.conto_descrizione}</span>
                  ) : (
                    <span style={{ color: "#c62828", fontWeight: 700 }}>⚠ NON MAPPATO</span>
                  )}
                </td>
                <td style={{ textAlign: "center" }}>
                  <button onClick={() => apriPicker(r)} data-testid={`pn-mapping-edit-${i}`}
                    style={{ padding: "3px 9px", background: mapped ? "#1565c0" : "#1b5e20", color: "white", border: "none", fontSize: 10, fontWeight: 700, cursor: "pointer", marginRight: 3 }}>{mapped ? "✏" : "+ Mappa"}</button>
                  {mapped && (
                    <button onClick={() => rimuovi(r)} data-testid={`pn-mapping-del-${i}`}
                      style={{ padding: "3px 8px", background: "white", color: "#c62828", border: "1px solid #c62828", fontSize: 10, fontWeight: 700, cursor: "pointer" }}>🗑</button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {pickerOpen && pickerCau && (
        <ContoPickerSezione9 cau={pickerCau} voci={voci}
          onClose={() => { setPickerOpen(false); setPickerCau(null); }}
          onSelect={sceglConto}
          onContoCreated={() => setVoci([])} />
      )}
    </div>
  );
}

function ContoPickerSezione9({ cau, voci, onClose, onSelect, onContoCreated }) {
  const [search, setSearch] = useState("");
  const [newConto, setNewConto] = useState(null);
  // Determina la sezione Ricavi dalle voci esistenti (root livello 1 con "ricav")
  const root = voci.find(v => v.livello === 1);
  const sezC0 = root ? root.c0 : 2;
  // Ordine gerarchico naturale: prima i nodi padre (livello 1 → 2 → 3) poi le foglie
  const sorted = [...voci].sort((a, b) => (
    (a.c0 ?? -1) - (b.c0 ?? -1) || (a.c1 ?? -1) - (b.c1 ?? -1) ||
    (a.c2 ?? -1) - (b.c2 ?? -1) || (a.c3 ?? -1) - (b.c3 ?? -1) ||
    (a.id_conto ?? 0) - (b.id_conto ?? 0)
  ));
  const filtered = search
    ? sorted.filter(v => (`${v.id_conto} ${v.descrizione}`).toLowerCase().includes(search.toLowerCase()))
    : sorted;
  const indentFor = (v) => {
    const lvl = v.livello || (v.is_foglia ? 4 : 1);
    return Math.max(0, (lvl - 1)) * 18;
  };
  const colorFor = (v) => {
    if (v.is_foglia) return "#1b5e20";
    if (v.livello === 1) return "#0d47a1";
    if (v.livello === 2) return "#1565c0";
    return "#37474f";
  };
  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 700, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div onClick={e => e.stopPropagation()} data-testid="pn-mapping-picker"
        style={{ background: "white", width: 760, maxHeight: "85vh", display: "flex", flexDirection: "column" }}>
        <div style={{ background: "#1b5e20", color: "white", padding: "8px 14px", display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontWeight: 700, fontSize: 13 }}>💰 Mappa &quot;{cau.cau_des}&quot; (Cau {cau.cau_code})</span>
          <input value={search} onChange={e => setSearch(e.target.value)} data-testid="pn-mapping-picker-search"
            placeholder="🔍 Cerca conto..." style={{ flex: 1, padding: "4px 10px", border: "none", fontSize: 12, marginLeft: 6, color: "#1b5e20", fontWeight: 600 }} />
          <button onClick={() => setNewConto({ c0: sezC0, c1: 1, c2: 1, descrizione: "" })} data-testid="pn-mapping-newconto"
            style={{ padding: "4px 12px", background: "#fbc02d", color: "#0d47a1", border: "none", fontWeight: 800, fontSize: 12, cursor: "pointer" }}>+ Nuovo conto</button>
          <button onClick={onClose} style={{ padding: "4px 10px", background: "white", color: "#1b5e20", border: "none", fontWeight: 700, cursor: "pointer" }}>✕</button>
        </div>
        <div style={{ flex: 1, overflow: "auto", fontSize: 12 }}>
          {filtered.length === 0 && (
            <div style={{ padding: 30, textAlign: "center", color: "#888" }}>
              Nessuna voce di bilancio &quot;Ricavi&quot; trovata.<br/>
              <span style={{ fontSize: 11 }}>Crea prima una sezione Ricavi nel Piano dei Conti (livello 1 con descrizione contenente &quot;ricav&quot;).</span>
            </div>
          )}
          {filtered.map(v => {
            const cliccabile = !!v.is_foglia;
            return (
              <div key={v.id_conto}
                onClick={() => cliccabile && onSelect(v.id_conto)}
                data-testid={cliccabile ? `pn-mapping-pick-${v.id_conto}` : undefined}
                style={{
                  padding: "7px 14px 7px " + (14 + indentFor(v)) + "px",
                  cursor: cliccabile ? "pointer" : "default",
                  borderBottom: "1px solid #eee",
                  display: "flex", alignItems: "center", gap: 10,
                  background: cliccabile ? "white" : "#f5f5f5",
                  fontWeight: cliccabile ? 400 : 700,
                  color: colorFor(v),
                }}
                onMouseEnter={e => { if (cliccabile) e.currentTarget.style.background = "#e8f5e9"; }}
                onMouseLeave={e => { if (cliccabile) e.currentTarget.style.background = "white"; }}>
                <span style={{ fontFamily: "monospace", color: "#888", minWidth: 70 }}>
                  {v.c0 ?? "-"}.{v.c1 ?? "-"}.{v.c2 ?? "-"}.{v.c3 ?? "-"}
                </span>
                <b style={{ color: colorFor(v), fontFamily: "monospace", minWidth: 50 }}>[{v.id_conto}]</b>
                <span style={{ flex: 1, textTransform: cliccabile ? "uppercase" : "none" }}>{v.descrizione}</span>
                {cliccabile && <button style={{ padding: "3px 10px", background: "#1b5e20", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>✓ Scegli</button>}
              </div>
            );
          })}
        </div>
        <div style={{ padding: "6px 14px", background: "#f5f5f5", fontSize: 11, color: "#555", borderTop: "1px solid #ddd" }}>
          {filtered.filter(v => v.is_foglia).length} conti foglia · {filtered.length} voci totali · sezione Ricavi
        </div>
      </div>
      {newConto && (
        <NuovoContoModal draft={newConto} setDraft={setNewConto}
          onClose={() => setNewConto(null)}
          onCreated={(v) => { setNewConto(null); if (onContoCreated) onContoCreated(); if (v && onSelect) onSelect(v.id_conto); }} />
      )}
    </div>
  );
}
